import script from "./MobileChatMessages.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileChatMessages.vue?vue&type=script&setup=true&lang=ts"

import "./MobileChatMessages.vue?vue&type=style&index=0&id=71a57e6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a57e6d"]])

export default __exports__